import React, { Fragment } from 'react'
import { toast } from 'react-toastify';
import { get } from 'lodash'
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
export const sellerDetails = () => {
  try {
    return JSON.parse(localStorage.getItem("sellerDetails"))
  } catch (error) {
    return null
  }
}

export const notify = (type, message, promise = null) => {
  if (type === "promise") {
    toast.promise(
      promise,
      {
        pending: 'Please Wait ...',
        success: message || 'Success 👌',
        error: message || 'Error 🤯',
      },
      {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 900,
        hideProgressBar: true,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
        theme: 'light',
      }
    );
  }
  else {
    toast[type](message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1500,
    })
  }
}
export const handleError = error => {
  if (error?.response?.data?.message === 'Unauthorized access') {
    notify('error', error.response.data.message)
  }
  if (error?.response && error?.response.data) {
    if (error?.response?.data?.error) {
      const err = get(error, 'response.data.error', '')
      if (
        get(err, 'code', '') === 401 &&
        get(err, 'stack', '') === 'Unauthorized access'
      ) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        return
      }
      toast(
        ({ closeToast }) =>
          typeof err === 'string'
            ? err.includes('not a valid phone number') ||
              err.includes('is not an SMS enabled phone number')
              ? 'That phone number is not recognized'
              : err
            : Object.keys(err).map((element, index) => (
              <Fragment key={index}>
                {err[element]}
                <br />
              </Fragment>
            )),
        {
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      )
    } else {
      notify('error', error.response.data.message)
    }
  } else if (error.message) {
    notify(
      'error',
      error.message === 'Network Error'
        ? 'You are offline, please check your internet connection'
        : error.message
    )
  } else {
    notify('error', 'Something went wrong!')
  }
}

export const copyToClipboard = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() =>
      notify("success", `${text} copied to clipboard!`)
    )
    .catch((error) => notify("error", "Failed to copy text"));
};


export function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = ((lat2 - lat1) * Math.PI) / 180; // Convert degrees to radians
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers

  return distance;
}

export async function getDistanceNew(lat1, lon1, lat2, lon2) {
  try {
    // console.log(lat1, lon1, lat2, lon2,'lat1, lon1, lat2, lon2')
    const source = `${lat1},${lon1}`;
    const destination = `${lat2},${lon2}`;

    const options = {
      method: "post",
      url: `${process.env.REACT_APP_KIKO_API_BASE_URL_v3}/api/v1/maps/getDistanceFromGoogleAPI-Ola`,
      headers: { desktop: true },
      data: {  source, destination },
    };

    const res = await axios(options);
    console.log("Distance Response:", res?.data);

    if (res?.data?.success) {
      const value = res.data.data;
      return value === "NaN" ? 0 : parseFloat(value);
    }

    return 0;
  } catch (err) {
    console.error("Distance API error:", err);
    return 0;
  }
}

export function sortByDistance(sellers, defaultLat, defaultLon) {
  try {
    return sellers
      .map((seller) => {
        const gps = seller?.locations?.[0]?.gps;
        if (!gps) return { ...seller, distance: Infinity }; // If no GPS, move to bottom
        const [sellerLat, sellerLon] = gps.split(",").map(Number);
        return {
          ...seller,
          distance: getDistance(defaultLat, defaultLon, sellerLat, sellerLon),
        };
      })
      .sort((a, b) => (b.isFavorite - a.isFavorite) || (a.distance - b.distance));
  } catch (err) {
    return sellers
  }
};

export const isStoreOpen = (storeDetails) => {
  if (
    !storeDetails ||
    !storeDetails.locations ||
    storeDetails.locations.length === 0
  ) {
    return false;
  }
  const currentDate = new Date();
  const currentDay = currentDate.getDay(); // Get current day (0-6, where 0 is Sunday)
  const currentTime = currentDate.getHours() * 100 + currentDate.getMinutes(); // Get current time in HHMM format
  const { label, range } = storeDetails.locations[0].time || {};
  if (label === "close") {
    return false;
  } else if (label === "open") {
    return true;
  } else if (label === "enable") {
    const holidays = storeDetails.locations[0].schedule?.holidays || [];
    const isHoliday = holidays.includes(
      currentDate.toISOString().split("T")[0]
    );
    if (isHoliday) {
      return false;
    }
    const openingDays = (storeDetails.locations[0].time?.days || "")
      .split(",")
      .map((day) => parseInt(day));
    if (!openingDays.includes(currentDay)) {
      return false;
    }
    const { start, end } = range || {};
    const startTime = parseInt(start);
    const endTime = parseInt(end);
    if (
      !isNaN(startTime) &&
      !isNaN(endTime) &&
      currentTime >= startTime &&
      currentTime <= endTime
    ) {
      return true;
    }
  }
  return false;
};


export const errorCodeMessages = (code, message) => {
  const errorMessages = {
    "40002": "Out of stock",
    "40003": "Quote unavailable",
    "40004": "Payment type not supported",
    "40005": "Tracking not enabled",
    "40006": "Fulfilment agent unavailable",
    "40007": "Change in item quantity",
    "40008": "Change in quote",
    "40009": "Maximum order quantity exceeded",
    "30009": "Location Serviceability error.",
    "30017": "Merchant Unavailable",
    "40012": "Minimum item quantity error",
  };
  // If the code exists in errorMessages, return the corresponding message
  if (errorMessages[code]) {
    return errorMessages[code];
  }
  // If message is provided and it's an object or array, return it directly
  if (message && (typeof message === 'object' || Array.isArray(message))) {
    return message;
  }
  // If message is a string, return the string, otherwise return default error message
  return message || "Uh-oh! Seller facing a technical issue";
};

export const orderStatus = (status) => {
  const statusMessages = {
    "Accepted": " Order Accepted",
    "Created": "Order Placed",
    "In-progress": "In Progress",
    "Completed": "Delivered",
    "Cancelled": "Order Cancelled"
  };
  return statusMessages[status] || status;
};

export const deliveryStatus = (status) => {
  const statusMessages = {
    "Packed": "Parcel Packed",
    "Pending": "Delivery Pending",
    "Order-picked-up": "Parcel Picked Up",
    "Out-for-delivery": "Parcel Out For Delivery",
    "Order-delivered": "Parcel Delivered"
  };
  if (statusMessages[status]) {
    return statusMessages[status]
  }
  else if (status && status !== '' && status?.length > 0) {
    return status
  }
  else {
    return "Delivery Pending"
  }
};

export const formatAndLocalizeText = (text) => {
  const textObject = {
    "Kilogram": "kg",
    "kilogram": "kg",
    "gram": "g",
    "millilitre": "ml"
  };
  return textObject[text] || text
};

export const types = [
  {
    value: "ORD01",
    label: "ORDER",
    subcategories: [
      { value: "ORD01", label: "Order not received" },
      { value: "ORD02", label: "Quality issue" },
      { value: "ORD03", label: "Delayed delivery" },
      { value: "ORD04", label: "Invoice missing" },
      { value: "ORD05", label: "Store not responsive" },
    ],
  },
  {
    value: "ITM01",
    label: "ITEM",
    subcategories: [
      { value: "ITM01", label: "Missing items" },
      { value: "ITM02", label: "Quantity issue" },
      { value: "ITM03", label: "Item mismatch" },
      { value: "ITM04", label: "Quality issue" },
      { value: "ITM05", label: "Expired item" },
      { value: "ITM06", label: "Incorrectly marked as returned" },
    ],
  },
  {
    value: "FLM01",
    label: "FULFILLMENT",
    subcategories: [
      { value: "FLM01", label: "Wrong delivery address" },
      { value: "FLM02", label: "Delay in delivery" },
      { value: "FLM03", label: "Delayed delivery" },
      { value: "FLM04", label: "Packaging" },
      { value: "FLM07", label: "Package info mismatch" },
      { value: "FLM08", label: "Incorrectly marked as delivered" },
    ],
  },
  {
    value: "PMT01",
    label: "PAYMENT",
    subcategories: [
      { value: "PMT01", label: "Refund not received" },
      { value: "PMT02", label: "Underpaid" },
      { value: "PMT04", label: "Not paid" },
    ],
  },
];

export const getBreadcrumbMapping = (selectedVariant, storeName, category, categoryName) => ({
  "seller": storeName || "Store",
  "": "Home",
  "product-details": selectedVariant?.productName || "Product Details",
  "buyer-checkout": "Checkout",
  "category": category ? category : categoryName ? categoryName : "Category",
  "mobile-search-result": "Search Results",
  "top-grocery-stores": "Top Grocery Stores"
});

export const breadcrumbText = (path, pathArray, selectedVariant, storeName, category, categoryName) => {
  const breadcrumbMapping = getBreadcrumbMapping(selectedVariant, storeName, category, categoryName);
  let breadcrumbText = ""
  if (path === "/") {
    breadcrumbText = "Home"
  }
  else {
    breadcrumbText =
      breadcrumbMapping[pathArray[pathArray.length - 1]] ||
      pathArray.join(" ");
  }
  return breadcrumbText;
}

export const breadcrumbLinkPath = (path, sellerData, subCategoryId) => {
  const catagory = subCategoryId?.replace(/&/gi, "%26")
  const encodedPId = encodeURIComponent(sellerData?.providerId);
  const encodedProductId = encodeURIComponent(sellerData?.productId);
  switch (path) {
    case "/seller":
      return `/seller?pid=${encodedPId}`;
    case "/":
      return "/";
    case "/product-details":
      return {
        pathname: `/product-details?providerId=${encodedPId}&productCode=${encodedProductId}`,
        state: {
          catalogDataArray: {},
        },
      };
    case "/buyer-checkout":
      return "/buyer-checkout";
    case "/category":
      return `/category?name=${catagory}`;
    case "/mobile-search-result":
      return "/mobile-search-result";
    case "/top-grocery-stores":
      return `/top-grocery-stores`;
    default:
      return path;
  }
}

export const handleAddToCart = (productName, productId, category, quantity, price, storeName) => {
  if (process.env.REACT_APP_NODE_ENV === "production" && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      "currency": "USD",
      "value": price,
      "items": [{
        "item_name": `${storeName} - ${productName}`,
        "item_id": productId,
        "item_category": category,
        "quantity": quantity,
        "item_brand": storeName
      }]
    });
  } else {
    console.warn("Google Analytics is not initialized");
  }
};

export const handleViewItem = (productName, productId, category, price, storeName) => {
  if (process.env.REACT_APP_NODE_ENV === "production" && window.gtag) {
    window.gtag('event', 'view_item', {
      "currency": "USD",
      "value": price,
      "items": [{
        "item_name": `${storeName} - ${productName}`,
        "item_id": productId,
        "item_category": category,
        "item_brand": storeName
      }]
    });
  } else {
    console.warn("Google Analytics is not initialized");
  }
};

//handle checkout
export const handleCheckout = (productName, productId, category, price, storeName) => {
  if (process.env.REACT_APP_NODE_ENV === "production" && window.gtag) {
    window.gtag('event', 'checkout', {
      "currency": "USD",
      "value": price,
      "items": [{
        "item_name": `${storeName} - ${productName}`,
        "item_id": productId,
        "item_category": category,
        // "quantity": quantity,
        "item_brand": storeName
      }]
    });
  } else {
    console.warn("Google Analytics is not initialized");
  }
};

//handle purchase
export const handlePurchase = (productName, productId, category, price, storeName) => {
  if (process.env.REACT_APP_NODE_ENV === "production" && window.gtag) {
    window.gtag('event', 'purchase', {
      "currency": "USD",
      "value": price,
      "items": [{
        "item_name": `${storeName} - ${productName}`,
        "item_id": productId,
        "item_category": category,
        // "quantity": quantity
        "item_brand": storeName
      }]
    });
  } else {
    console.warn("Google Analytics is not initialized");
  }
};

export const shopBackgrounds = [
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/7bAHwH0Zx.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/epNkQznxS.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/smp7e8nvR.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/pPcvvO2Fj.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/WfJS5j4Cd.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/MYGvccYCU.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/WxaIywUb8.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/0X16uUVcg.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/s4gPnMDRS.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/e7_LGn7uW.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/q83QkxHZJ.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/cSFQ8kyuY.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/kpWjSlzbi.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/xyu0QzCjZ.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/lYYGFZN-9.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/dH9P6JSed.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/lYS5sWqm8.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/ezOzkGJHH.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/bMBY6CdZ4.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/M6ScOU7Cs.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/K6FsMdsQt.png",
  "https://kikonewapi.s3.ap-south-1.amazonaws.com/uploads/user_images/MBDXlZXQj.png"
];


